import React, { useEffect, useState } from "react";
import CustomListing from "../components/CustomListing";
import { useDirectCustomerApi } from "../api/direct_customers";
import ReusableHeader from "../components/ReusableHeader";
import CustomButton from "../components/CustomButton";
import { formatDate } from "../util/date";
import { decodeJwt } from "../util/decodeJwt";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useUsersApi } from "../api/users";
import ReusableFilter from "../components/ReusableFilter";
import { Filter, Pencil, Trash } from "lucide-react";

export default function CustomerManagement() {
  const { getAllDirectCustomers ,deleteDirectCustomer} = useDirectCustomerApi();
  const navigate = useNavigate(); // <- call hook inside component
  const [userId, setUserId] = useState("");

  // ✅ Filter state
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filterObject, setFilterObject] = useState({}); // ✅ store filters
  const [rows, setRows] = useState([]);
  const [searchText, setSearchText] = useState(""); // ✅ search state


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = decodeJwt(token);
        if (decoded?._id) {
          setUserId(decoded._id);
        }
      } catch (err) {
        console.error("JWT decode failed", err);
      }
    }
  }, []);

  const handleDelete = async (id) => {
    if (!userId) {
      toast.error("Unauthorized: User not found");
      return;
    }

    if (window.confirm("Are you sure you want to delete this User?")) {
      try {
        debugger
        await deleteDirectCustomer(id, userId); // call API
        toast.success("Org deleted successfully");

        // ✅ reload or trigger refresh in CustomListing
        window.location.reload();
      } catch (err) {
        toast.error(err.message || "Failed to delete Org");
      }
    }
  };

  const statusStyles = {
    active: { color: "#1b5e20", backgroundColor: "#c8e6c9" },   // green
    inactive: { color: "#b71c1c", backgroundColor: "#ffcdd2" }, // red
  };
  const columns = [
    { key: "name", label: "Name" },
    { key: "address", label: "Address" },
    { key: "vendor",  label: "Vendor", render: (row) => row.vendor?.name },
    { key: "phoneNumber",  label: "PhoneNumber", render: (row) => row?.phoneNumber },
  {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="action-buttons">
          {/* Edit button */}
          <CustomButton
            label={<Pencil size={16} />}
            className="edit-btn"
            onClick={() => navigate(`/customers/edit/${row._id}`)}
          />

          {/* Delete button */}
          <CustomButton
            label={<Trash size={16} />}
            className="delete-btn"
            onClick={() => handleDelete(row._id)}
          />
        </div>
      ),
    }
  ];

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      debugger
      const decoded = decodeJwt(token);
      setUserId(decoded?._id || "Unknown User");
    } else {
      setUserId("Unknown User");
    }
  }, []);

  // ✅ Debounced fetch when search or filters change
  useEffect(() => {
    const delayDebounce = setTimeout(async () => {
      if (!userId) return;
      try {
        const data = await fetchWithFilters({ limit: 10, offset: 0, vendorId: userId });
        setRows(data.data);
      } catch (err) {
        toast.error(err.message || "Failed to fetch customers");
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchText, filterObject, userId]);

  const renderActionButtons = (row) => (
    <div className="header-buttons" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <input
        type="text"
        className="search-input"
        placeholder="Search Customers..."
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
      <CustomButton
        className="header-btn"
        label="New Customer"
        onClick={() => navigate("/customers/create")} // <- use navigate
      />
  </div>
  );


  const fetchWithFilters = async (params) => {
    return await getAllDirectCustomers({
      ...params,
      ...filterObject,         // date filters
      search: searchText || undefined, // search string
    });
  };
    
    // ✅ Apply filters
    const handleApplyFilters = () => {
      const newFilters = {};
      if (fromDate) newFilters.fromDate = fromDate;
      if (toDate) newFilters.toDate = toDate;
  
      setFilterObject(newFilters);
      setIsFilterOpen(false);
      toast.success("Filters applied");
    };
  
    // ✅ Remove filter
    const handleRemoveFilter = (key) => {
      const updated = { ...filterObject };
      delete updated[key];
      setFilterObject(updated);
  
      if (key === "fromDate") setFromDate("");
      if (key === "toDate") setToDate("");
    };
  
      // ✅ Convert filterObject to activeFilters array
    const activeFilters = Object.entries(filterObject).map(([key, value]) => {
      let label = key;
      if (key === "fromDate") label = "From";
      if (key === "toDate") label = "To";
      return { key, label, value };
    });
  

  return (
     <div className="inventoryManagement">

     <ReusableHeader title="Customer Management" children={renderActionButtons()} />
      {/* ✅ Active Filters Chips */}
      <div className="filter-chips-container">
        {activeFilters.map((filter, index) => (
          <div key={index} className="filter-chip">
            {filter.label}: {filter.value}
            <span
              className="remove-icon"
              onClick={() => handleRemoveFilter(filter.key)}
            >
              ✕
            </span>
          </div>
        ))}
      </div>
     {userId && (
        <CustomListing
           data={rows}         // controlled rows
          setData={setRows}   // setter to update table instantly
          fetchData={fetchWithFilters}
          columns={columns}
          pageSize={10}
          showCheckbox={false}   // ✅ THIS HIDES CHECKBOX
          postData={{ vendorId: userId }}
        />
      )}
      {/* ✅ ReusableFilter for date inputs */}
      <ReusableFilter isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)} title="Filter Devices">
        <div className="filter-fields">
          <div className="filter-row">
            <label>From Date</label>
            <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
          </div>

          <div className="filter-row">
            <label>To Date</label>
            <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
          </div>

          <div className="filter-actions">
            <CustomButton className="apply-btn" label="Apply" onClick={handleApplyFilters} />
            <CustomButton
              className="clear-btn"
              label="Clear"
              onClick={() => {
                setFromDate("");
                setToDate("");
                setFilterObject({});
                setIsFilterOpen(false);
              }}
            />
          </div>
        </div>
      </ReusableFilter>
    </div>
  );
}